/**
 * Top Bar 2
 */
(() => {
  const quickOrderWrapper = document.querySelector('.topbar-2 .quick-order-wrapper');
  const quickOrder = document.querySelector('header .header-full .quickordertoggle');
  if (quickOrderWrapper && quickOrder) {
    quickOrderWrapper.append(quickOrder);
  }

  const quickListWrapper = document.querySelector('.topbar-2 .quick-list-wrapper');
  const quickList = document.querySelector('header .header-full .vuequicklistdropdown_elem');
  if (quickListWrapper && quickList) {
    quickListWrapper.replaceWith(quickList);
  }
})();
